<template>
  <div>
    <!-- Start Header Area -->
    <Header default-color="black">
      <img
          slot="logo"
          src="../../assets/images/layout/smile-logo.svg"
          class="logo-light"
          width="200"
          alt="Smile Magazine Logo"
      />
      <img
          slot="logo-dark"
          src="../../assets/images/layout/smile-logo.svg"
          class="logo-dark"
          alt="Smile Magazine Logo"
      />
    </Header>
    <!-- End Header Area -->

    <!-- Start Gallery Area  -->
    <div class="rn-gallery-area bg_color--1" style="margin-top: 108px;">
      <div class="creative-portfolio-wrapper plr--10">
        <v-row class="row--5">
          <!-- Start Single Portfolio  -->
          <v-col
              lg="3"
              md="4"
              sm="6"
              cols="12"
              v-for="(item, i) in postList"
              :key="i"
          >
            <div class="portfolio-style--3">
              <div class="thumbnail">
                <router-link :to="`/blog/${item.slug}`">
                  <img class="w-100" :src="item.src" alt="Portfolio Images" />
                </router-link>
              </div>
              <div class="content">
                <p class="portfoliotype">{{ item.meta }}</p>
                <h4 class="heading-title">
                  <router-link :to="`/blog/${item.slug}`">{{ item.title }}</router-link>
                </h4>
                <div class="portfolio-btn">
                  <router-link class="rn-btn white--text" :to="`/blog/${item.slug}`"
                  >Leer más</router-link
                  >
                </div>
              </div>
            </div>
          </v-col>
          <!-- End Single Portfolio  -->
        </v-row>
      </div>
    </div>
    <!-- End Gallery Area  -->

    <!-- Start Footer Area  -->
    <Footer />
    <!-- End Footer Area  -->
  </div>
</template>

<script>
  import Header from "../layout/header/HeaderOnePage.vue";
  import LatestPosts from "./LatestPosts.vue";
  import BlogTwo from "../../components/blog/BlogTwo";
  import Blog from "../../components/blog/Blog";
  import Pagination from "../../components/pagination/Pagination";
  import Footer from "../../pages/layout/footer/Footer.vue";
  import {PostsService} from "@/pages/blog/posts.service";
  import config from "@/config/config";
  import {container} from "@/main";
  import PortfolioFive from "@/components/portfolio/PortfolioFive.vue";
  export default {
    components: {
      PortfolioFive,
      Header,
      LatestPosts,
      BlogTwo,
      Blog,
      Pagination,
      Footer,
    },
    computed: {
      categoryData() {
        return config.categories[this.$route.params.categoria];
      }
    },
    data() {
      return {
        postList: [],
        postService: null,
      };
    },
    watch: {
      async '$route'(to, from) {
        if (to.name === 'Blog by category') {
          await this.fetchData(this.$route.params.categoria);
        }
      },
    },
    async created() {
      if (this.$route.name === 'Blog by category') {
        await this.fetchData(this.$route.params.categoria);
      }
    },
    methods: {
      decodeHtml(html) {
        const textarea = document.createElement('textarea');
        textarea.innerHTML = html;
        return textarea.value;
      },
      async fetchData(categoryId) {
        this.postService = container.get(PostsService);
        const posts = await this.postService.getLastPostsByCategory(this.categoryData.id);
        this.postList = posts.map(post => ({
          src: post.jetpack_featured_media_url,
          meta: this.categoryData.name,
          title: this.decodeHtml(post.title.rendered),
          link: post.link,
          slug: post.slug,
          id: post.id,
        }));
      }
    },
  };
</script>
